import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import ImageZoom from '../ImageZoom';
import Title from '../Title';
import HeaderWrapper from '../HeaderWrapper';
import CodeBlock from '../CodeBlock';
import MicrositeSteps from '../Microsites/Steps';
import MicrositeFurtherReading from '../Microsites/FurtherReading';
import DefinitionTooltip from '../DefinitionTooltip';
import VideoWrapper from '../VideoWrapper';

const portalComponents = {
  Title,
  HeaderWrapper,
  ImageZoom,
  CodeBlock,
  MicrositeSteps,
  MicrositeFurtherReading,
  DefinitionTooltip,
  VideoWrapper
};

const PortalsRenderer = ({ portals, meta, canUseDom }) => (
  portals.map(({ component, containerID, props }) => {
    const container = canUseDom && document.getElementById(`${containerID}`);
    if (!container) return null;

    const Component = portalComponents[component];
    return createPortal(
      <Component {...props} meta={meta} />, document.querySelector(`#${containerID}`)
    );
  })
);

PortalsRenderer.propTypes = {
  portals: PropTypes.array.isRequired,
  meta: PropTypes.object.isRequired
};

export default PortalsRenderer;
